<template>
  <div class="section-main__warp meeting-manage">
    <!--参数面板组件-->
    <appCrudTab title="筛选面板">
      <template slot="form">
        <el-form :inline="true" :model="params">
          <el-form-item label="任务名称">
            <el-input class="roomname-input" placeholder="请输入任务名称" v-model="params.name"></el-input>
          </el-form-item>
          <el-form-item label="日期范围">
            <el-date-picker class="meeting-time-range" v-model="params.dates" type="daterange" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="巡更人员">
            <el-input class="roomname-input" placeholder="请输入巡更人员" v-model="params.peopleName"></el-input>
          </el-form-item>
          <el-form-item label="任务状态">
            <el-select v-model="params.statusVal" placeholder="全部">
              <el-option v-for="item in statusData" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否逾期">
            <el-select v-model="params.overdue" placeholder="全部">
              <el-option v-for="item in overdueList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
    </appCrudTab>
    <!--数据面板-->
    <div style="
        flex: 1;
        display: flex;
        flex-direction: column;
        background: #fff;
        margin-top: 15px;
        padding: 0 15px;
        height: 0;
      ">
      <div class="ioc-crud__table" style="flex: 1; display: flex; flex-direction: column; overflow-y: auto">
        <div class="mt-1 mb-1" style="margin: 10px 0">
          <el-button @click="handleDelete">删除</el-button>
        </div>
        <!-- tableColumns -->
        <el-table style="flex: 1" ref="multipleTable" stripe :data="tableData" @selection-change="changeSelection">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
          <el-table-column prop="taskName" label="巡检任务名称" align="center" width="300"></el-table-column>
          <el-table-column label="巡检计划时间" align="center" width="300">
            <template slot-scope="scope">
              <span>{{ scope.row.startDate }} 至 {{ scope.row.endDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际巡检时间" align="center" width="300">
            <template slot-scope="scope">
              <span>{{ scope.row.actualStartDate }}
                {{
                  scope.row.actualStartDate || scope.row.actualEndDate
                  ? "至"
                  : ""
                }}
                {{ scope.row.actualEndDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="巡检人员" align="center"></el-table-column>
          <el-table-column label="巡检进度" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.clockPoint }} / {{ scope.row.totalPoint }}</span>
            </template>
          </el-table-column>
          <el-table-column label="任务状态" align="center">
            <template slot-scope="scope">
              <span>{{
                dealValueToLabel(scope.row.taskStatus, statusData)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否逾期" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.overDate == "1" ? "是" : "否" }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="查看" placement="top-start">
                <i class="item-operation-icon el-icon-view icon-blue" @click="handleOpenInfo(scope.row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="top-start">
                <i class="item-operation-icon el-icon-delete icon-blue" @click="handleDeleteOne(scope.row)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="el-table__empty-block">
              <span class="el-table__empty-text">
                <div class="ioc-crud__empty">
                  <div class="ioc-empty">
                    <div class="ioc-empty__image" style="height: 50px">
                      <img src="../img/empty.svg" alt="" />
                    </div>
                    <p class="ioc-empty__desc">暂无数据</p>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="meeting-footer">
      <el-pagination background @size-change="pageSizeChange" @current-change="pageNoChange" :current-page.sync="pageNo"
        :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <history-info-component v-if="visible" @handleCancel="handleCancel" :id="detailFormId" />
  </div>
</template>

<script>
import HistoryInfoComponent from "@/modules/equipInspection/components/historyInfoComponent";
import appCrudTab from "../components/app-crud-tab/index.vue";
import api from "../api/index";
export default {
  name: "history",
  components: { HistoryInfoComponent, appCrudTab },
  data() {
    return {
      visible: false,
      checkedData: [],
      tableData: [],
      tableLoading: false,
      detailFormId: {},
      statusData: [
        { label: "全部任务", value: "" },
        { label: "未开始", value: "0" },
        { label: "执行中", value: "1" },
        { label: "已完成", value: "2" },
      ],
      overdueList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
      params: {
        name: "",
        dates: [],
        statusVal: "",
        peopleName: "",
        overdue: "",
      },
      pageNo: 1,
      pageSize: 20,
      total: 0,
      tableColumns: [
        {
          label: "序号",
          prop: "index",
          width: 60,
        },
        {
          label: "巡检任务名称",
          prop: "taskName",
          width: "280",
        },
        {
          label: "计划巡检时间",
          prop: "taskPlanTime",
          width: "280",
        },
        {
          label: "实际巡检时间",
          prop: "taskDatetimeRange",
          width: "280",
        },
        {
          label: "巡检人员",
          prop: "username",
        },
        {
          label: "巡检进度",
          prop: "taskProgress",
        },
        {
          label: "任务状态",
          prop: "taskStatus",
        },
        {
          label: "是否逾期",
          prop: "overDate",
        },
        {
          label: "操作",
          prop: "operating",
        },
      ],
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    // 任务列表查询
    /**
     * 记录信息查询
     */
    queryData() {
      let url =
        api.task.getTaskList +
        `?pageNumber=${this.pageNo}&pageSize=${this.pageSize}&planType=1`;
      this.tableLoading = true;

      if (this.params.name) {
        url += `&taskName=${this.params.name}`;
      }
      if (this.params.dates && this.params.dates.length) {
        url += `&startDate=${this.params.dates[0]}&endDate=${this.params.dates[1]}`;
      }
      if (this.params.peopleName) {
        url += `&username=${this.params.peopleName}`;
      }
      if (this.params.statusVal) {
        url += `&taskStatus=${this.params.statusVal}`;
      }
      if (this.params.overdue) {
        url += `&overDate=${this.params.overdue}`;
      }
      this.$fetchGet(url).then((res) => {
        this.tableLoading = false;
        if (res.success) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    /**
     * 记录信息查询
     */
    handleSearch() {
      this.pageNo = 1;
      this.queryData();
    },
    /**
     * 重置
     */
    handleReset() {
      this.params = {
        name: "",
        dates: [],
        statusVal: "",
        peopleName: "",
        overdue: "",
      };
      this.pageNo = 1;
      this.pageSize = 20;
      this.queryData();
    },
    /**
     * 每页记录数改变触发
     * @param pageSize 记录值
     */
    pageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.queryData();
    },
    /**
     * 当前页改变触发
     * @param pageNo 当前页码
     */
    pageNoChange(pageNo) {
      this.pageNo = pageNo;
      this.queryData();
    },
    // 任务列表查询

    /**
     * 表格选中回调
     * @param val 选中值 array
     */
    changeSelection(val) {
      this.checkedData = val;
    },
    // 删除
    handleDelete() {
      var _this = this;
      if (this.checkedData.length === 0) {
        this.$message.warning("请先选择对象");
        return;
      }
      this.$confirm('确认删除？', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let idArr = _this.checkedData.map(item => {
            return item.taskId
          })
          let _par = {
            recordId: idArr.join(","),
          };
          let url = api.task.deleteTasks + _par.recordId
          this.$fetchDelete(url).then((res) => {
            if (res.success) {
              this.$message.success("删除成功");
              this.handleSearch();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        })
        .catch(() => {

        });
    },
    // 打开详情
    handleOpenInfo(row) {
      this.visible = true;
      this.detailFormId = row.taskId;
    },
    // 删除
    handleDeleteOne(row) {
      this.$confirm('确认删除？', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = api.task.deleteTask + row.taskId
          this.$fetchDelete(url).then((res) => {
            if (res.success) {
              this.$message.success("删除成功");
              this.handleSearch();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        })
        .catch(() => { });
    },
    handleCancel() {
      this.visible = false;
    },
    // 选项value和label之前的转换
    dealValueToLabel(value, arr) {
      let result = "";
      if (!value || !arr) {
        return result;
      } else {
        arr.forEach((item) => {
          if (item.value == value) {
            result = item.label;
          }
        });
        return result;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.meeting-manage {
  display: flex;
  flex-direction: column;

  .item-operation-icon {
    font-size: 14px;
    cursor: pointer;
    margin: 0 8px;
  }


  //
  .meeting-footer {
    background: #fff;
    display: flex;
    justify-content: center;
    padding: 15px 0;
  }
}

.alarm_options {
  display: flex;
  flex-direction: row;

  .options_icon {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;

    &:hover {
      // @include set_primary_theme(color);
    }
  }
}
</style>
